import { render, staticRenderFns } from "./rmsg.vue?vue&type=template&id=5420ca34&scoped=true&"
import script from "./rmsg.vue?vue&type=script&lang=js&"
export * from "./rmsg.vue?vue&type=script&lang=js&"
import style0 from "./rmsg.vue?vue&type=style&index=0&id=5420ca34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5420ca34",
  null
  
)

export default component.exports